export default __webpack_public_path__ + "static/media/compusoluciones.4761d696.png";